export default "__VITE_ASSET__RK_xK3sN__"